(function () {
    'use strict';

    angular.module('app.help', [
        'app.core',
        'app.widgets'
    ]);
})();
